// smooth scroll to location on contact page when map marker is clicked
function mapScroll(marker) {
	let locationSections = document.querySelectorAll('.h2'),
		markerName = marker.firstChild.getAttribute('data-location-description'),
		x_coordinate = 0;

	for ( var i = 0; i < locationSections.length; i++ ) {
		locationSections[i].innerText === markerName ? x_coordinate = locationSections[i].getBoundingClientRect().y-250: '';
	}
	window.scrollTo({ top: x_coordinate, behavior: 'smooth' });
}
